import React from "react";
import { motion } from "framer-motion";

// List of OEM Partners from your Sitemap/Profile PDF
// Replace the 'image' property with your actual logo URLs
const PARTNERS = [
  {
    name: "HERO MOTOCORP",
    id: 1,
    image: "partner-images/hero.png",
  },
  {
    name: "HONDA",
    id: 2,
    image: "partner-images/honda.png",
  },
  {
    name: "MARUTI SUZUKI",
    id: 3,
    image: "partner-images/suzuki.png",
  },
  {
    name: "YAMAHA",
    id: 4,
    image: "partner-images/yamaha.png",
  },
  {
    name: "TATA MOTORS",
    id: 5,
    image: "partner-images/tata.png",
  },
  {
    name: "MAHINDRA",
    id: 6,
    image: "partner-images/mahindra.png",
  },
  {
    name: "KIA MOTORS",
    id: 8,
    image: "partner-images/kia.png",
  },
  {
    name: "ASHOK LEYLAND",
    id: 9,
    image: "partner-images/ashok-layland.png",
  },
  {
    name: "TVS MOTOR",
    id: 10,
    image: "partner-images/tvs.png",
  },
  {
    name: "BAJAJ AUTO",
    id: 11,
    image: "partner-images/bajaj.png",
  },
  {
    name: "KAWASAKI",
    id: 12,
    image: "partner-images/kawasaki.png",
  },
  {
    name: "PIAGGIO",
    id: 14,
    image: "partner-images/piaggio.png",
  },
];
const PARTNERS2 = [
  {
    name: "AV Light",
    id: 1,
    image: "partner-images-2/av-light.png",
  },
  {
    name: "JNS",
    id: 2,
    image: "partner-images-2/jns.png",
  },
  {
    name: "LS",
    id: 3,
    image: "partner-images-2/ls.png",
  },
  {
    name: "LUMAX",
    id: 4,
    image: "partner-images-2/lumax.png",
  },
  {
    name: "NS",
    id: 5,
    image: "partner-images-2/ns.png",
  },
  {
    name: "PLEM",
    id: 6,
    image: "partner-images-2/plem.png",
  },
  {
    name: "PRICOL",
    id: 8,
    image: "partner-images-2/pricol.png",
  },
  {
    name: "RINDER",
    id: 9,
    image: "partner-images-2/rinder.png",
  },
  {
    name: "SL LUMAX",
    id: 10,
    image: "partner-images-2/sl-lumax.png",
  },
  {
    name: "U",
    id: 11,
    image: "partner-images-2/u.png",
  },
  {
    name: "UNO",
    id: 12,
    image: "partner-images-2/uno.png",
  },
  {
    name: "VARROC",
    id: 14,
    image: "partner-images-2/varroc.png",
  },
  {
    name: "VIET NAM NS",
    id: 15,
    image: "partner-images-2/viet-nam-ns.png",
  },
];

const PartnersCarousel = ({ isDesktop, THEME }) => {
  return (
    <section
      id="partners"
      style={{
        // backgroundColor: "#09090b", // Dark background to contrast with previous white section
        // paddingLeft: isDesktop ? "280px" : "0",
        // padding: "80px 0",
        paddingBottom: "80px",
        overflow: "hidden",
        position: "relative",
      }}
    >
      {/* Section Header */}
      <div
        style={{
          maxWidth: "1400px",
          margin: "0 auto",
          padding: "0 24px 48px 24px",
          textAlign: "left",
        }}
      >
        <h3
          style={{
            color: THEME.colors.accent, // Gold Accent
            fontSize: "14px",
            fontWeight: 800,
            textTransform: "uppercase",
            letterSpacing: "0.2em",
            marginBottom: "16px",
          }}
        >
          Powering Global OEMs
        </h3>
        <h2
          style={{
            color: "black",
            fontSize: "32px",
            fontWeight: 900,
            textTransform: "uppercase",
            margin: 0,
          }}
        >
          Trusted by Industry Leaders
        </h2>
      </div>

      {/* Carousel Track */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 50,
        }}
      >
        <h3
          style={{
            color: THEME.colors.accent, // Gold Accent
            fontSize: "18px",
            fontWeight: 800,
            textTransform: "uppercase",
            letterSpacing: "0.2em",
            marginBottom: "16px",
            textAlign: isDesktop ? "left" : "center",
            paddingLeft: isDesktop ? "100px" : "0",
          }}
        >
          Global OEMs
        </h3>
        <div
          style={{
            display: "flex",
            position: "relative",
            width: "100%",
            maskImage:
              "linear-gradient(to right, transparent, black 10%, black 90%, transparent)",
            WebkitMaskImage:
              "linear-gradient(to right, transparent, black 10%, black 90%, transparent)",
          }}
        >
          {/* We render the list twice to create the seamless loop effect */}
          <CarouselTrack dir="left" items={PARTNERS} THEME={THEME} />
          <CarouselTrack dir="left" items={PARTNERS} THEME={THEME} />
        </div>
        <h3
          style={{
            color: THEME.colors.accent, // Gold Accent
            fontSize: "18px",
            fontWeight: 800,
            textTransform: "uppercase",
            letterSpacing: "0.2em",
            marginBottom: "16px",
            textAlign: isDesktop ? "left" : "center",
            paddingLeft: isDesktop ? "100px" : "0",
          }}
        >
          Lightening partners
        </h3>
        <div
          style={{
            display: "flex",
            position: "relative",
            width: "100%",
            maskImage:
              "linear-gradient(to right, transparent, black 10%, black 90%, transparent)",
            WebkitMaskImage:
              "linear-gradient(to right, transparent, black 10%, black 90%, transparent)",
          }}
        >
          {/* We render the list twice to create the seamless loop effect */}
          <CarouselTrack dir="right" items={PARTNERS2} THEME={THEME} />
          <CarouselTrack dir="right" items={PARTNERS2} THEME={THEME} />
        </div>
      </div>
    </section>
  );
};

const CarouselTrack = ({ dir, items, THEME }) => {
  return (
    <motion.div
      animate={{ x: dir === "left" ? ["0%", "-100%"] : ["-100%", "0%"] }}
      transition={{
        ease: "linear",
        duration: 80, // Slightly slower for better visibility of logos
        repeat: Infinity,
      }}
      style={{
        display: "flex",
        flexShrink: 0,
        gap: "64px", // Space between logos
        paddingRight: "64px", // Compensate for gap at the end
        minWidth: "100%",
      }}
    >
      {items.map((partner, index) => (
        <div
          key={`${partner.id}-${index}`}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            opacity: 0.6,
            transition: "all 0.3s ease",
            cursor: "pointer",
            height: "70px", // Fixed height container
            minWidth: "150px", // Minimum width for logos
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.opacity = 1;
            e.currentTarget.style.transform = "scale(1.1)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.opacity = 0.6;
            e.currentTarget.style.transform = "scale(1)";
          }}
        >
          <img
            src={partner.image}
            alt={partner.name}
            style={{
              maxHeight: "100%",
              maxWidth: "100%",
              objectFit: "contain",
            }}
          />
        </div>
      ))}
    </motion.div>
  );
};

export default PartnersCarousel;
